import { render, staticRenderFns } from "./addLink.vue?vue&type=template&id=e20a4980&scoped=true&"
import script from "./addLink.vue?vue&type=script&lang=js&"
export * from "./addLink.vue?vue&type=script&lang=js&"
import style0 from "./addLink.vue?vue&type=style&index=0&id=e20a4980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20a4980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20a4980')) {
      api.createRecord('e20a4980', component.options)
    } else {
      api.reload('e20a4980', component.options)
    }
    module.hot.accept("./addLink.vue?vue&type=template&id=e20a4980&scoped=true&", function () {
      api.rerender('e20a4980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/aliAppLink/addLink.vue"
export default component.exports